import React from "react";
import { useDiaryContext } from "../../../../../../hooks/useDiaryContext";
import { useAppContext } from "../../../../../../hooks/useAppContext";
import {
  validateCustomFieldsData,
  formatFieldValue
} from "../../../../../../utils/customFields";

type CustomFieldsProps = {
  showHeader?: boolean;
};

export const CustomFields = ({ showHeader = true }: CustomFieldsProps) => {
  const { selectedBooking, selectedBookingV4, venueConfig } = useDiaryContext();
  const { venueGroupConfig } = useAppContext();

  if (selectedBooking && !selectedBookingV4) {
    return null; // Still loading detailed booking data
  }

  const validationData = validateCustomFieldsData(
    selectedBookingV4,
    venueConfig,
    venueGroupConfig
  );

  const { completedFields } = validationData || { completedFields: [] };

  return (
    <div className="customFields mb-4">
      {showHeader && completedFields.length > 0 && (
        <div className="customFieldsLabel font-semibold text-sm text-primary-color mb-3">
          Special Requests
        </div>
      )}
      {completedFields.length > 0 && (
        <ul className="customFieldsList flex flex-col gap-2 list-none p-0 m-0">
          {completedFields.map((field, index) => {
            const fieldName =
              (field as any).labels || field.label || (field as any).name;
            const fieldValue = formatFieldValue(field);
            return (
              <li
                key={field.id || index}
                className="customField flex items-center gap-1"
              >
                <span className="customFieldLabel font-bold text-[13px] text-primary-color">
                  {fieldName}:
                </span>
                <span className="customFieldValue text-[13px] text-primary-color">
                  {fieldValue}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
